import { v4 as uuid } from 'uuid';
import { HelpCircle, LifeBuoy } from 'react-feather';

export const HelpCenterContactData = [
	{
		id: uuid(),
		icon: <HelpCircle size="40" strokeWidth="1.5" className="text-primary" />,
		title: 'Kontaktiere uns',
		link: '/marketing/pages/contact',
		description:
			'Du hast eine Frage zu unseren Produkten oder Dienstleistungen? Kontaktiere uns über das Kontaktformular und wir helfen dir gerne weiter.',
		linkname: 'Zum Kontaktformular'
	},
	{
		id: uuid(),
		icon: <LifeBuoy size="40" strokeWidth="1.5" className="text-primary" />,
		title: 'Service Ticket erstellen',
		link: '/marketing/help-center/support/',
		description:
			'Deine Frage oder Problem kann nicht gelöst werden? Kontaktiere unseren HelpDesk für eine Unterstützung. Dieser Service steht nur unseren registrierten Kunden zur Verfügung.',
		linkname: 'Erstelle ein Service Ticket'
	}
];

export default HelpCenterContactData;
